<template>
    <div>
        <Row>
            <Col span="4" v-if="!resource_id">
                <Upload 
                :action="uploadUrl"
                :on-success="handleSuccess"
                :on-preview="filePreview"
                :on-remove="fileRemove"
                :before-upload="brforeUpload"
                :disabled="disabled"
                ref="upload" 
                :data="{...file_type,create_user_id: create_user_id}"
                 style="display:inline-block;width:200px">
                    <Button :disabled="disabled">{{lang=='zh'?chName.selectFile:enName.selectFile}}</Button>
                </Upload> 
            </Col>
            <Col span="4" v-if="resource_id" :disabled="disabled">
                <span style="cursor:pointer" :disabled="disabled" @click="filePreview()">{{fileName}}</span>
                <span class="ivu-icon ivu-icon-ios-trash" style="font-size: 18px;color:red" :disabled="disabled" @click="fileRemove()"></span>
            </Col>           
            <Col span="13" v-show="!resource_id">
                <p style="display:inline;">{{lang=='zh'?chName.fileCheck:enName.fileCheck}}</p>
            </Col>
        </Row>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    props: {
        file_type: {
            type: Object,
            default: function () {
                return {
                }
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            resource_id: '',
            uploadUrl: '/api/resource/upload',
            fileName: '',
            isHistory: false,
            create_user_id: JSON.parse(sessionStorage.getItem('userInfo')).userId,
            accept: '.xlsx,.xls',
            uploadFormat: ['xlsx','xls'],
            chName:{},
            enName:{},
        };
    },
    computed: {
      //国际化监听
      lang(){
        return this.$store.getters.selectLangeData
      },
    },
    created() {
      this.getInternation()
    },
    methods: {
        getInternation(){
          let Obj = {
              viewType:"Common",
              beUsed : "1"
          } 
          axios.post('/International/applySelectViewSet',Obj).then((res) => {
            console.log(res)     
              this.chName= res.data[0]
              this.enName= res.data[1]
            })
        },
        handleFormatError(file, fileList) {
            this.$Message.warning({
                content: file.name + this.$t('The_file_type_is_incorrect') + this.uploadFormat.join(' or ') + this.$t('Type'),
                duration: 5
            })
        },
        setFileInfo(id, name){
            this.resource_id = id
            this.fileName = name
        },
         // 上傳文件成功后的操作
        handleSuccess(res, file) {
            this.resource_id = file.response.data;
            this.fileName = file.name
            this.$emit('handleOK',this.resource_id, file)
        },
        filePreview(file) {           
            this.$donwLoad(this.resource_id); // 当前下载的文件ID
        },
        // 删除文件操作
        fileRemove(file,fileList){
            if(this.disabled) {
                return
            }
            this.$emit('handleDel',this.resource_id)
            this.resource_id = ''
        },
        
         brforeUpload(file){ // 文件上传之前的钩子 
            const mainImg = this.$refs.upload; // 如果已经有文件  侧删除列表中的文件
            mainImg.clearFiles();
         },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/FileUP.vue